import { lazy } from 'react'
import { Link } from 'react-router-dom'
import MaterialLink, { linkClasses } from '@mui/material/Link'
import styled from '@emotion/styled'
import Chip from './Chip/Chip'
import TableLinkButton from './TableLinkButton/TableLinkButton'
import TableTrend from './TableTrend/TableTrend'
import MaterialTooltip from './Tooltip/Tooltip'

const StyledLink = styled(MaterialLink)(({ theme }) => ({
  ...theme.typography.button,
  fontWeight: 500,
  color: theme.vars.palette.text.primary,
  transitionProperty: 'color, text-decoration-color',
  transitionDuration: `${theme.transitions.duration.standard}ms}`,
  [`.${linkClasses.root}:hover`]: {
    color: theme.vars.palette.primary.main,
  },
}))

const componentsMapping = {
  FormNewsletterTelegram: lazy(
    () => import('components/FormNewsletterTelegram/FormNewsletterTelegram')
  ),
  GeneralData: lazy(() => import('components/GeneralData/GeneralData')),
  NumberStats: lazy(() => import('components/Card/NumberStats/NumberStats')),
  PieChart: lazy(() => import('components/PieChart/PieChart')),
  HalfPieChart: lazy(() => import('components/HalfPieChart/HalfPieChart')),
  DirectionsList: lazy(
    () => import('components/DirectionsList/DirectionsList')
  ),
  LineChart: lazy(() => import('components/LineChart/LineChart')),
  Accordion: lazy(() => import('components/Accordion/Accordion')),
  Stack: lazy(() => import('components/Stack/Stack')),
  DataGrid: lazy(() => import('components/DataGrid/DataGrid')),
  CardContentTabs: lazy(
    () => import('components/CardContentTabs/CardContentTabs')
  ),
  ContentTabs: lazy(() => import('components/ContentTabs/ContentTabs')),
  ChipsPanel: lazy(() => import('components/ChipsPanel/ChipsPanel')),
  ListItemLink: lazy(() => import('components/ListItemLink/ListItemLink')),
  TableLinkButton,
  TableTrend,
  Chip,
  Link: ({ href, label }) => (
    <StyledLink component={Link} to={href} underline="always">
      {label}
    </StyledLink>
  ),
  MaterialTooltip,
}

export function MappedComponent({ name, props }) {
  const Component = componentsMapping[name]

  if (!Component) return null

  return <Component {...props} />
}
